import { render, staticRenderFns } from "./contentCourseExamArticle.vue?vue&type=template&id=10457bf2&"
import script from "./contentCourseExamArticle.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports